import styled from 'styled-components';

/**
 * The WebGL aurora canvas. Fills the section behind the frosted glass (z-index 0);
 * `display: block` kills the inline-canvas baseline gap. Sized in device pixels by
 * the component (DPR-aware) and stretched to the box via CSS.
 */
export const Canvas = styled.canvas`
  position: absolute;
  inset: 0;
  z-index: 0;
  display: block;
  width: 100%;
  height: 100%;
  pointer-events: none;
`;
